
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { maska } from 'maska'
import { IFlexMessageBubble, IFlexMessageCarousel, IFlexMessageTemplate } from '@/utils/types'
import CLoading from '@/components/common/ui/CLoading.vue'
import FlexMessageTemplateFormModal from '@/components/story/common/flex-message/FlexMessageTemplateFormModal.vue'
import { Prop, Watch } from 'vue-property-decorator'
import { ACTION_FLEX_MESSAGE_TEMPLATE } from '@/store/actions'

@Options({
  components: { FlexMessageTemplateFormModal, CLoading },
  directives: { maska },
  emits: ['update:selectTemplate', 'onAddTemplate', 'update:altText'],
})
export default class FlexMessageTemplateModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  template!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  previewImageUrl!: string

  @Prop()
  imgFile!: File

  @Prop()
  isMessageChanged!: boolean

  @Prop()
  isAdmin!: boolean

  @Prop()
  isSuper!: boolean

  @Prop()
  altText!: string

  templates: IFlexMessageTemplate[] = []
  standardTemplates: IFlexMessageTemplate[] = []
  customTemplates: IFlexMessageTemplate[] = []
  selectedTemplate: IFlexMessageTemplate = {}
  chooseTemplate: IFlexMessageTemplate = {}
  loading = true
  search = ''
  templateModalVisible = false
  hoverId = ''
  hoverImg = ''
  hoverX = 0
  hoverY = 0
  bar = 'standard'
  componentKey = 1

  get tabs() {
    return this.bar
  }

  set tabs(tab: string) {
    this.bar = tab
  }

  get appId() {
    return this.$route.params.app_id as string
  }

  async onSearchTemplate() {
    this.loading = true
    await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.LOAD_ITEMS, {
      app_id: this.appId,
      template_type: this.tabs,
      filter: {
        name: this.search,
      },
    })
    this.loading = false
  }

  onSelectTemplate(item: IFlexMessageTemplate) {
    this.chooseTemplate = item
  }

  onAdd() {
    if (this.template === undefined || this.template === null) {
      this.$q.notify({
        message: 'Template is not defined. Please create a template first.',
        color: 'negative',
      })
      return
    }
    this.selectedTemplate = {}
    this.selectedTemplate.contents = this.template
    this.templateModalVisible = true
    this.$emit('onAddTemplate')
  }

  onEdit(message: IFlexMessageTemplate) {
    this.selectedTemplate = message
    this.templateModalVisible = true
  }

  async onDelete(template: IFlexMessageTemplate) {
    this.$q
      .dialog({
        title: this.$t('confirm'),
        message: this.$t('are_you_sure_you_want_to_delete'),
        cancel: true,
        persistent: true,
      })
      .onOk(async () => {
        const success = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.DELETE, template._id)
        if (success) {
          this.$q.notify({
            message: this.$t('messages.deleted'),
            color: 'positive',
          })
          await this.loadTemplates()
        }
      })
  }

  onCloseModal() {
    this.selectedTemplate = {}
    this.templateModalVisible = false
  }

  onSubmit() {
    this.$emit('update:selectTemplate', this.chooseTemplate)
  }

  onHover(row) {
    this.hoverId = row._id
    this.hoverImg = row.img
    document.addEventListener('mousemove', this.onMouseMove)
  }

  onLeave() {
    this.hoverId = ''
    this.hoverImg = ''
    document.removeEventListener('mousemove', this.onMouseMove)
  }

  onMouseMove = (e: MouseEvent) => {
    this.hoverX = e.clientX + 10
    this.hoverY = e.clientY - 100
  }

  @Watch('tabs')
  @Watch('standardTemplates')
  @Watch('customTemplates')
  fetchTemplates() {
    if (this.tabs === 'standard') {
      this.templates = this.standardTemplates
    } else {
      this.templates = this.customTemplates
    }
    this.componentKey++
  }

  async loadTemplates() {
    this.standardTemplates = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.LOAD_ITEMS, {
      app_id: this.appId,
      template_type: 'standard',
    })
    this.customTemplates = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.LOAD_ITEMS, {
      app_id: this.appId,
      template_type: 'custom',
    })
  }

  async mounted() {
    await this.loadTemplates()
    this.templates = this.standardTemplates
    this.loading = false
  }
}
